import { Col, Container, Row } from "react-bootstrap";
import * as yup from "yup";
import { PHONE_REGEX, toWebp } from "../../../utils/common";
import dynamic from "next/dynamic";
import styles from "./style.module.scss";
import { useEffect, useRef } from "react";

const BannerHireNowForm = dynamic(() =>
	import("../../forms/banner-hire-now-form")
);

const Banner = (props) => {
	const { block } = props;

	const divRef = useRef(null);

	const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

	useEffect(() => {
		const imageUrl = toWebp(baseUrl + block?.banner_image?.data?.attributes?.url);
		divRef.current.style.backgroundImage = `url(${imageUrl})`;
	}, [block, baseUrl]);

	const bannerFormSchema = yup
		.object({
			employee_name: yup.string().trim().required("Name is required."),
			employee_email: yup
				.string()
				.email("Email is not valid.")
				.required("Email is required."),
			contact_no: yup
				.string()
				.min(10, "Invalid phone number")
				.max(13, "Invalid phone number")
				.matches(PHONE_REGEX, "Invalid phone number"),
			company_name: yup.string(),
			requirements: yup.string().trim().required("Requirements are required."),
		})
		.required();

	const bannerFormInitialValues = {
		employee_name: "",
		employee_email: "",
		contact_no: "",
		company_name: "",
		requirements: "",
	};

	return (
		<section
			ref={divRef}
			className={`contact-new-section section-pad-top-banner ${styles["home-banner-section"]}  ${styles["technology-new-section"]}`}
		>
			<Container className={styles["container"]}>
				<Row >
					{/* className={styles["small-reverse-row"]} */}
					<Col lg={6} md={6}>
						<div className={styles["banner-content"]}>

							<h1 className="text-white">{block?.title}</h1>

							<p className="text-white font-medium">{block?.description}</p>

							<ul className={styles["banner-tags"]}>
								{block?.services?.map((service, index) => (
									<li key={service.id}>{service.label}</li>
								))}
							</ul>
						</div>
					</Col>
					<Col lg={6} md={6}>
						<div className="contact-right-form bg-white border-2 border-color">
							<h3 className="text-large font-semibold text-black">
								{block?.form_title}
							</h3>
							<BannerHireNowForm
								schema={bannerFormSchema}
								initialValues={bannerFormInitialValues}
								isNew={true}
							/>

						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Banner;
